/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetWebhookRequestsResult } from '../../models/get-webhook-requests-result';

export interface ApiWebhooksWebhookIdRequestsGet$Params {
  webhookId: string;
  cursor?: string;
  limit?: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiWebhooksWebhookIdRequestsGet(http: HttpClient, rootUrl: string, params: ApiWebhooksWebhookIdRequestsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetWebhookRequestsResult>> {
  const rb = new RequestBuilder(rootUrl, apiWebhooksWebhookIdRequestsGet.PATH, 'get');
  if (params) {
    rb.path('webhookId', params.webhookId, {});
    rb.query('cursor', params.cursor, {});
    rb.query('limit', params.limit, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetWebhookRequestsResult>;
    })
  );
}

apiWebhooksWebhookIdRequestsGet.PATH = '/api/Webhooks/{webhookId}/requests';
